// The quote funnel's stepper, shared by every page in it so the labels and
// their order can't drift apart.
//
// Three steps, per the checkout redesign, all under /quote-setup/:id —
// Customise (index), Review & details (/details), Payment (/payment).
// /quote-preview/:id was the old Payment URL; server/redirects.js forwards it.
export const QUOTE_STEPS = ['Customise', 'Review & details', 'Payment']
// Mobile header's "Next:" label, and each step's path under /quote-setup/:id.
export const QUOTE_STEP_SHORT = ['Customise', 'Review', 'Payment']
export const QUOTE_STEP_PATHS = ['', '/details', '/payment']

export const QUOTE_STEP_SETUP = 0
export const QUOTE_STEP_DETAILS = 1
export const QUOTE_STEP_PREVIEW = 2
export const QUOTE_STEP_PAYMENT = 2

// Changing a live policy (MTA): /dashboard/policy-edit, -review and
// -mta-complete, all under the policy's code. Same header as the quote funnel,
// its own steps.
export const MTA_STEPS = ['Edit policy', 'Review', 'Done']
export const MTA_STEP_SHORT = ['Edit', 'Review', 'Done']
export const MTA_STEP_PATHS = [
  '/dashboard/policy-edit',
  '/dashboard/policy-review',
  '/dashboard/policy-mta-complete',
]

export const MTA_STEP_EDIT = 0
export const MTA_STEP_REVIEW = 1
export const MTA_STEP_DONE = 2

// FunnelHeader's `steps` for the MTA pages. Done steps link back while there's
// still something to go back to: not once the change is paid for.
export function mtaSteps(policyCode, activeStep) {
  return MTA_STEPS.map((label, index) => ({
    label,
    short: MTA_STEP_SHORT[index],
    to:
      index < activeStep && activeStep !== MTA_STEP_DONE
        ? `${MTA_STEP_PATHS[index]}/${policyCode}`
        : null,
  }))
}

// Pages that render the funnel header (components/quote-setup/FunnelHeader)
// in place of the site navigation and footer.
export function hasFunnelHeader(path) {
  return /^\/(quote-setup|dashboard\/policy-(edit|review|mta-complete))\//.test(
    path || ''
  )
}
